import { render, staticRenderFns } from "./UserModal1.vue?vue&type=template&id=f2e5ecf8&scoped=true"
import script from "./UserModal1.vue?vue&type=script&lang=js"
export * from "./UserModal1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e5ecf8",
  null
  
)

export default component.exports